import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Clock, AlertTriangle } from "lucide-react";

interface InactivityWarningDialogProps {
  open: boolean;
  remainingTime: number;
  onStayLoggedIn: () => void;
}

export function InactivityWarningDialog({
  open,
  remainingTime,
  onStayLoggedIn,
}: InactivityWarningDialogProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent className="sm:max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
              <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <AlertDialogTitle className="text-xl">
              Sessie verloopt binnenkort
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-base">
            Je wordt over{" "}
            <span className="font-semibold text-foreground inline-flex items-center gap-1">
              <Clock className="h-4 w-4" />
              {remainingTime} {remainingTime === 1 ? "seconde" : "seconden"}
            </span>{" "}
            automatisch uitgelogd wegens inactiviteit.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="mt-4">
          <AlertDialogAction
            onClick={onStayLoggedIn}
            className="w-full sm:w-auto"
          >
            Blijf ingelogd
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
